import { useMemo } from "react";
import { ResolvedPlaceDataSubmission } from "../../types/Place";
import { Headings } from "../Headings";
import { PublicUserProfileLink } from "../PublicUserProfileLink/PublicUserProfileLink";

interface PlaceSubmissionVewCardProps {
  submission: ResolvedPlaceDataSubmission;
}

export default function PlaceSubmissionVewCard({
  submission,
}: PlaceSubmissionVewCardProps) {
  const headingContent = useMemo(() => {
    if (!submission.creator) {
      return "Data Submission";
    }

    return (
      <>
        <PublicUserProfileLink
          profile={submission.creator}
          size="sm"
          linkToProfile
        />
      </>
    );
  }, [submission]);

  return (
    <div className="submission-review-card place">
      <Headings.PhoneSubBox>{headingContent}</Headings.PhoneSubBox>
    </div>
  );
}
